<label class="group/checkbox flex cursor-pointer items-center gap-8" [for]="inputId">
    <input
        class="hidden"
        [id]="inputId"
        [checked]="checked()"
        [disabled]="disabled()"
        (change)="onModelChange(!checked())"
        type="checkbox"
    />

    <div
        class="z-10 flex size-[22px] min-w-[22px] items-center justify-center border-2 border-grey-400 bg-white transition-colors group-hover/checkbox:border-blue group-has-[:checked]/checkbox:bg-blue"
        [ngClass]="{ 'cursor-not-allowed !border-grey-400 !bg-grey-100 opacity-70': disabled() }"
    >
        <i
            class="icon-check hidden text-22 text-white transition-colors group-has-[:checked]/checkbox:flex"
            [ngClass]="{ '!text-grey-400 opacity-70': disabled() }"
        ></i>
    </div>

    <span class="leading-22 z-10 text-16 transition-colors">
        <ng-content />
    </span>
</label>
